'use client'

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { type UseUserResult, useLogout } from '@account-kit/react'
import { Bell, Briefcase, UserPlus } from 'lucide-react'
import Link from 'next/link'

type UserMenuProps = {
	user: NonNullable<UseUserResult>
}

export function UserMenu({ user }: UserMenuProps) {
	const { logout } = useLogout()

	const displayName = user.email ?? 'User'
	const initials = displayName.slice(0, 2).toUpperCase()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" className="relative size-[40px] rounded-full">
					<Avatar className="size-[40px] cursor-pointer rounded-[8px]!">
						<AvatarFallback className="rounded-full!">{initials}</AvatarFallback>
					</Avatar>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-56 bg-brand-dark">
				<DropdownMenuLabel>
					<div className="flex flex-col space-y-1">
						<p className="font-medium text-sm">{displayName}</p>
					</div>
				</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuItem asChild>
					<Link href="/portfolio" className="flex items-center">
						<Briefcase className="mr-2 h-4 w-4" />
						Portfolio
					</Link>
				</DropdownMenuItem>
				{/* Mobile only: Refer a friend */}
				<DropdownMenuItem className="min-[1200px]:hidden">
					<Link href="/referrals" className="flex items-center">
						<UserPlus className="mr-4 h-4 w-4" />
						Refer a friend
					</Link>
				</DropdownMenuItem>
				{/* Mobile only: Notifications */}
				<DropdownMenuItem className="md:hidden" disabled>
					<Bell className="mr-2 h-4 w-4" />
					Notifications
					<span className="ml-auto text-brand-muted text-xs">Soon</span>
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={() => logout()}>Log out</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
